module.exports = require('./lib/emoji');